import React, { useState, useContext, useEffect } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Button } from '../Common/Button';
import EventEmitter from 'eventemitter3';
import { ContentPanel, Footer, Fullscreen, Section } from '../Common/Modal/Fullscreen';
import { Header, LogoPanel } from '../Common';
import { useIntl } from 'react-intl';
import { ShopSettingsContext } from '../../FootprintTech/AppController';
import log, { LogMode } from '../../services/LogService';
import { colors } from '../../theme';
import {version} from '../../../../package.json';
import Events from '../Common/Modal/Events';
import { checkboxActive } from '../../assets/Images';

// Define CSS variables
const Variables = {
  polly: '#e0ecf8',
  almond: '#fdf5ec'
};

interface SuccessOutcomeProps {
  emitter: EventEmitter;
}

const Blank = styled.div`
  margin-top:40px;
`;

const Icon = styled.img`
  display: block;
  width: 32px;
  height: 32px;
  margin: 40px auto;
`;

const SuccessOutcomeComponent: React.FunctionComponent<SuccessOutcomeProps> = (props) => {
  const { emitter } = props;
  const intl = useIntl();

  const handleClose = (e) => {
    e.nativeEvent.stopImmediatePropagation();
    emitter.emit(Events.onCloseModalPress);
  }

  useEffect(() => {}, []);

  return (
    <Fullscreen
      emitter={emitter}
      isClosable={false}
      style={{
        backgroundImage: `linear-gradient(to bottom, ${Variables.polly}, ${Variables.almond})`,
      }}
    >
      <LogoPanel />
      <ContentPanel>
        <Header className="fpt--bottom-margin">
          <FormattedMessage id="drv.email-form.success.message" />
          <Icon src={checkboxActive} />
        </Header>
      </ContentPanel>
      <Footer className="disclaimer">
      { log.mode === LogMode.VERBOSE &&
        <Section>Driver version: {version}</Section>
      }
        <Section>
          <Button
            onClick={handleClose} type="button"
            className="wide-primary">
            <FormattedMessage id="common.acknowledge" />
          </Button>
        </Section>
      </Footer>
    </Fullscreen>
  )
};

export default SuccessOutcomeComponent;
